export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0013s_0000_Black-&-White-40.0e4aed6e.png";